var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#FAFAFA"},attrs:{"id":"dashboard-view","wrap":""}},[_c('GlobalToolbar'),_c('GlobalDrawer'),_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('v-container',{staticClass:"pr-5",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }